import {
  POL_GET_MONEDAS,
  POL_GET_PRODUCTOS,
  POL_GET_TIPOS_COBERTURA,
} from '../constants/action-types';


const initialState = {
  monedas: [],
  productos: [],
  tiposCobertura: [],
};

const getMonedas = (state, action) => ({
  ...state,
  monedas: action.payload,
});

const getProductos = (state, action) => ({
  ...state,
  productos: action.payload,
});

const getTiposCobertura = (state, action) => ({
  ...state,
  tiposCobertura: action.payload,
});


function poliza(state = initialState, action) {
  switch (action.type) {
    case POL_GET_MONEDAS:
      return getMonedas(state, action);
    case POL_GET_PRODUCTOS:
      return getProductos(state, action);
    case POL_GET_TIPOS_COBERTURA:
      return getTiposCobertura(state, action);
    default:
      return state;
  }
}

export default poliza;
